/**
 * Scales brand title text to fill available width on one line.
 * Used by the Branded footer section.
 */
class MsfBrandedFooter extends HTMLElement {
  connectedCallback() {
    // This element IS the titles container
    this.titles = this;

    this.fitLarge = this.dataset.fitLarge === 'true';
    this.fitSmall = this.dataset.fitSmall === 'true';
    if (!this.fitLarge && !this.fitSmall) return;

    this.sidePadding = Number(this.dataset.fitPadding);
    if (Number.isNaN(this.sidePadding)) this.sidePadding = 24;

    this.maxLarge = Number(this.dataset.fitMaxLarge) || 0;
    this.maxSmall = Number(this.dataset.fitMaxSmall) || 0;

    this.largeEl = this.fitLarge ? this.querySelector('[data-msf-fit="large"]') : null;
    this.smallEl = this.fitSmall ? this.querySelector('[data-msf-fit="small"]') : null;

    this.onResize = () => this.scheduleFit();
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this);
    window.addEventListener('resize', this.onResize, { passive: true });

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.fitAll());
    } else {
      this.fitAll();
    }

    this.onSectionLoad = () => this.scheduleFit();
    document.addEventListener('shopify:section:load', this.onSectionLoad);
    document.addEventListener('shopify:section:reorder', this.onSectionLoad);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
    document.removeEventListener('shopify:section:reorder', this.onSectionLoad);
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  scheduleFit() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => {
      this.raf = null;
      this.fitAll();
    });
  }

  fitAll() {
    if (this.largeEl) this.fitElement(this.largeEl, this.maxLarge);
    if (this.smallEl) this.fitElement(this.smallEl, this.maxSmall);
  }

  fitElement(el, maxSize) {
    const containerWidth = this.clientWidth;
    if (!containerWidth) return;

    const available = Math.max(containerWidth - this.sidePadding * 2, 20);

    el.style.whiteSpace = 'nowrap';
    el.style.display = 'block';
    el.style.width = 'auto';
    el.style.maxWidth = 'none';
    el.style.marginInline = 'auto';
    el.style.paddingInline = '0';

    const hardMax = maxSize > 0 ? maxSize : Math.min(Math.floor(available * 1.2), 800);
    let low = 8;
    let high = hardMax;
    let best = low;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      el.style.fontSize = `${mid}px`;

      if (el.scrollWidth <= available + 0.5) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    el.style.fontSize = `${best}px`;
  }
}

if (!customElements.get('msf-branded-footer')) {
  customElements.define('msf-branded-footer', MsfBrandedFooter);
}
